import { Outlet } from "react-router-dom";
import Header from "../common/Header";
import Footer from "../common/Footer";
import { useTheme } from "@mui/material";

export default function Dashboard() {
  const theme = useTheme();
  return (
    <>
      <Header />
      <div
        style={{
          paddingTop: "142px",
          background: theme.palette.second_blue_prime,
        }}
      >
        <Outlet />
      </div>
      <Footer />
    </>
  );
}
